// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__TW9i0","empty":"ModalGraph_empty__1wM0_"};